import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetNewSubscribersInput } from '../domain/dtos/get-new-subscribers-input'
import { GetNewSubscribersOutput } from '../domain/dtos/get-new-subscribers-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { GetOfferIds } from './get-offer-ids'

export class GetNewSubscribers {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetNewSubscribersInput, signal?: AbortSignal): Promise<GetNewSubscribersOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/receiver/summary/subscriptions/newers`,
      body: this.makeBody(input),
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeBody(input: GetNewSubscribersInput) {
    const offerIds = new GetOfferIds().execute({ offerIds: input.offerIds, offers: input.offers })

    const body = {
      startDate: input.startDate,
      endDate: input.endDate,
      offerIds,
    }

    return body
  }
}
